import type { GradingId } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { RefObject } from "react";
import { useOutletContext } from "react-router";

export interface TranscriptScrollPosition {
  gradingId: GradingId;
  scrollTop: number;
}

export interface TrainingTeammatePageOverviewGradingContext {
  transcriptScrollPositionRef: RefObject<TranscriptScrollPosition | null>;
}

export function useTrainingTeammatePageOverviewGradingContext(): TrainingTeammatePageOverviewGradingContext | null {
  return useOutletContext<TrainingTeammatePageOverviewGradingContext | null>();
}
